import '../../node_modules/scrollreveal/dist/scrollreveal.min.js';
import '../../node_modules/owl.carousel2/dist/owl.carousel.min.js';
import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '../../node_modules/doc-cookies/cookies_min.js';
import '../../node_modules/cookieconsent/build/cookieconsent.min.js';

( ($) => {

  'use strict';

  $(document).ready( () => {

    //--------------------------------------------------------------
    // Header Toggle Nav
    //--------------------------------------------------------------
    $('.NavigationToggle').click( function() {
      $(this).toggleClass('is-open');
      $('.Navigation--mobile').slideToggle(200);
    });

    $('.Navigation--mobile li').has('ul').prepend('<span class="Navigation-arrow"><i class="fa fa-angle-down"></i></span>');
    $('.Navigation-arrow').click( function() {
      $(this).find('i').toggleClass(' fa-angle-down');
      $(this).find('i').addClass(' fa-angle-up');
      $(this).parent().find('ul:first').slideToggle(200);
    });

    //--------------------------------------------------------------
    // Header Search
    //--------------------------------------------------------------
    $('.SearchForm--header .SearchForm-button').click( (e) => {
      e.preventDefault();
      const SearchForm = $('.SearchForm--header');
      SearchForm.toggleClass('is-active');
    });

    //--------------------------------------------------------------
    // Header Sticky
    //--------------------------------------------------------------
    $(window).scroll( () => {
      const scrollPosition = $(window).scrollTop();
      if (scrollPosition > 500) {
        $('.header--sticky').addClass('is-sticky');
      } else {
        $('.header--sticky').removeClass('is-sticky');
      }
    });

    //--------------------------------------------------------------
    // Sliders
    //--------------------------------------------------------------
    // @link https://github.com/OwlCarousel2/OwlCarousel2

    const sliderNavText = [
      '<i class="fa fa-angle-left" aria-hidden="true"></i>',
      '<i class="fa fa-angle-right" aria-hidden="true"></i>'
    ];

    // Testimonial Carousel
    $('.Testimonials-slider').owlCarousel({
      nav: true,
      dots: false,
      margin: 0,
      items: 1,
      loop: true,
      autoHeight: true,
      responsiveRefreshRate: 0,
      navText: sliderNavText
    });

    //--------------------------------------------------------------
    // Lightbox
    //--------------------------------------------------------------
    // @link https://github.com/fancyapps/fancybox
    $("[data-fancybox]").fancybox();

  });

  $(window).on('load', () => {

    //--------------------------------------------------------------
    // Masonry Grid
    //--------------------------------------------------------------
    // @link https://github.com/desandro/masonry

    $('.Gallery--masonry .Gallery-inner').masonry({
      itemSelector: '.Gallery-item',
      columnWidth: '.Gallery-item',
      percentPosition: false
    });

    //--------------------------------------------------------------
    // In ViewPort Animation
    //--------------------------------------------------------------
    // @link https://github.com/jlmakes/scrollreveal

    window.inViewport = ScrollReveal({});
    inViewport.reveal('.Card', {});
    inViewport.reveal('.Gallery [data-fancybox]', {
      scale: 1,
      delay: 200
    });

  });

})(jQuery);
